<template>
  <div
    style="position: relative; display: contents;"
    :class="is_secondary_order ? 'kds-secondary-order' : ''"
    :style="secondary_css_vars"
  >

    <v-card
      v-if="!settings.dark_mode"
      :width="items.length > 3 ? undefined : 300"
      :style="items.length > 3 ? { display: 'contents' } : {}"
      style="margin-bottom: 10px;"
      class="mt-2 mr-10"
      :class="[
        selected && items.length <= 3 ? 'selected-order-border' : ''
      ]"
      :loading="loading"
      :disabled="loading"
    >
        <v-card-title class="white--text pa-0 d-flex align-center" :class="[
        is_updated_order ? 'title-updated' : (is_deleted_order ? 'title-deleted' : 'blue-grey'),
        items.length > 3 ? 'kds-ghost-child elevation-2 rounded-t' : ''
      ]"
      @click="hide()">

            <div v-if="display_index !== null" class="kds-index-badge ml-2" :class="settings.dark_mode ? 'dark-badge' : 'light-badge'">
              {{ display_index }}
            </div>

            <div class="py-1 px-2 text-truncate text-subtitle-1 font-weight-bold text-left" style="flex: 1;">
              {{order.caption}}
            </div>

            <div class="pa-1 text-truncate font-weight-normal text-overline text-right" style="width: auto;">
              {{ getShorthandTime(order.created_at) }}
            </div>
            <div class="order-counter" style="color: white;"
              :class="is_updated_order ? 'counter-updated' : (is_deleted_order ? 'counter-deleted' : '')">
              <v-icon v-if="service_is_icon" color="white" class="mr-1" style="font-size: 16px;">{{ service }}</v-icon>
              <span v-else-if="service">{{ service }}</span>
              <span v-if="service" class="mx-1"> - </span>{{order.counter}}
            </div>
        </v-card-title>

        <v-card-text class="pa-0" style="display: contents;">

          <div
            v-for="(item, i) in items"
            :key="item.idx"
            class="kds-item-row my-1"
            :class="[
               // 1. GHOST MODE: Apply Card Styling directly to the item row
               items.length > 3 ? 'kds-ghost-item elevation-2' : '',

               // 2. Status styling
               ((order.is_deleted && !order.docstatus) || item.is_deleted) ? 'status-deleted' : (item.status === 'Ready' ? 'status-ready' : 'status-pending'),

               // 3. Rounded corners for the last item in the list
               (items.length > 3 && i === items.length - 1) ? 'rounded-b mb-4' : '',

               // 4. Left/right border indicators for ghost mode
               items.length > 3 ? (is_updated_order ? 'indicator-updated-side' : (is_deleted_order ? 'indicator-deleted-side' : '')) : '',

               // 5. Selection left/right borders for ghost mode
               items.length > 3 && selected ? 'selected-order-side' : ''
            ]"
            @click.stop="next(item)"
          >
            <div class="kds-item-qty-box" :class="status_class(item)">
              <div class="qty-val">{{ item.qty }}</div>
              <div class="uom-val">{{ item.uom }}</div>
            </div>

            <div class="kds-item-content">
              <div class="d-flex justify-space-between align-start">
                <span class="item-name-text" style="width: 80%; overflow-wrap: break-word;">{{ item.item_name }}</span>
                <span class="item-time-text">{{ getShorthandTime(item.last_updated) }}</span>
              </div>

              <div v-if="item.notes" class="item-note-text"># {{ item.notes }}</div>

              <div v-for="modifier in item.modifiers" :key="modifier.id" class="modifier-text">
                ↪ {{ modifier.qty ?? 1 }}x {{ modifier_map[modifier.type ?? 'Note'] }} {{ modifier.caption }}
              </div>
            </div>
          </div>
        </v-card-text>
    </v-card>

    <div v-else style="display: contents">
      <v-card-title
        class="white--text pa-0 d-flex align-center"
        :class="[
          selected ? 'selected-order-header' : '',
          is_updated_order ? 'title-updated' : (is_deleted_order ? 'title-deleted' : '')
        ]"
        @click.stop="hide()"
        style="margin-right: 20px;"
      >

          <div v-if="display_index !== null" class="pa-1 dark-badge text-truncate font-weight-normal text-center"
            style="height: auto; min-height: 33px; font-size: 12px; padding: 0 !important; width: auto; min-width: 33px;">
            {{ display_index }}
          </div>
        <div class="py-1 px-2 title text-truncate text-subtitle-1 font-weight-bold text-left"
          style="height: 30px; flex: 1;" :style="order.hidden ? 'background-color: rgb(3, 166, 139, 0.5) !important;' : ''">
          {{caption}}
        </div>

        <div class="pa-1 text-truncate font-weight-normal text-center"
          :class="time_class" style="font-size: 13px; padding: 0 !important; width: auto; min-width: 50px;">
          {{ getShorthandTime(order.created_at) }}
        </div>
        <div class="col-sm-3" style="font-size: 17px; color: #000; background-color: #FFFF99; transform: rotate(-10deg); right: -30px; text-align: center; overflow: hidden; height: 32px; line-height: 15px; padding: 0; display: flex; align-items: center; justify-content: center;">
          <v-icon v-if="service_is_icon" color="black" style="font-size: 16px;">{{ service }}</v-icon>
          <span v-else-if="service">{{ service }}</span>
          <br v-if="service" />
          {{order.counter}}
        </div>
      </v-card-title>
      <div v-for="item in items"
        :key="item.idx"
        class="row kds-item"
        :class="((order.is_deleted && !order.docstatus) || item.is_deleted) ? 'status-deleted': ''"
        :style="item.status == 'Ready' ? 'background-color: rgb(0, 0, 0, 0.6);' : 'background-color: rgb(0, 0, 0, 0.2);'"
        @click.stop="next(item)">
        <div
          class="col-sm-2"
          style="align-self: baseline; color: white; line-height: 15px; overflow: hidden; text-align: center; padding: 5px; font-weight: bolder; border: 0.5px white solid;"
          :class="status_class(item)">
          {{item.qty}}
          <div style="font-size: 12px; font-weight: normal; line-height: 6px; padding-top: 5px;">{{item.uom}}</div>
        </div>
        <div class="col-sm-10" style="color: #dedede; line-height: 15px; padding: 7px;">
          <span class="d-block item-name-text" style="width: 77%; overflow-wrap: break-word;">{{ item.item_name }}</span>
          <span class="text-caption" style="float: right;">
            {{ getShorthandTime(item.last_updated) }}
          </span>
          <span v-if="item.status == 'Ready'" style="float: right;">
            <i class="fa fa-check"></i>
          </span>
          <div v-if="item.notes" style="margin-top: 10px; margin-left: 10px; font-size: 14px;"># {{ item.notes }}</div>
          <div v-for="modifier in item.modifiers" :key="modifier.id" style="margin-top: 10px; margin-left: 10px; font-size: 14px;">
            {{ modifier.qty ?? 1 }} X  {{ modifier_map[modifier.type ?? 'Note'] }} {{modifier.caption}}
            <div v-if="modifier.notes" style="margin-top: 10px; font-size: 14px;"># {{ modifier.notes }}</div>
          </div>
        </div>
      </div>
      <div v-if="other_items && !settings.is_grouped"
        class="row kds-item"
        style="background-color: rgb(0, 0, 0, 0.2); height: 20px; cursor: pointer;"
        @click="expand = !expand">
        <div style="width: 100%; text-align: center; color: white; line-height: 10px; overflow: hidden; font-weight: bolder; font-size: larger;">...</div>
      </div>

      <div  v-if="order.remarks"
        style= "background-color: rgb(0, 0, 0, 0.2);"
        class="white--text col-sm-10 row kds-item">
        # {{order.remarks}}
      </div>

      <div class="row kds-break">
        &nbsp;
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { is_non_empty_array } from '../utils.js';

export default {
  name: 'KDSOrder',
  // [NEW] Added 'selected' prop
  props: {
    order_id: { required: true },
    selected: { type: Boolean, default: false },
    index: { type: Number, required: true },
    page_offset: { type: Number, default: 0 }
  },
  data: () => ({
    loading: false,
    error: null,
    modifier_map: {
      'Add': 'إضافة →',
      'Remove': 'بدون →',
      'Note': '#',
    },
    expand: false
  }),
  computed: {
    order() {
      return this.$store.state.orders[this.order_id]
    },
    visible_items() {
      const groups_visible = this.settings.selected_groups
      const items = this.order.items

      if (!is_non_empty_array(groups_visible)) return items
      return items.filter(item => groups_visible.includes(item.item_group))
    },
    items() { return !this.settings.is_grouped ? this.non_grouped_items : this.grouped_items },
    non_grouped_items() {
      return (this.expand ? this.order.items : this.visible_items).filter(item => !item.associated_to).map(item => {
        if (item.modifiers && item.modifiers.length > 0) {
          for (let modifier of item.modifiers) {
            if (modifier.associated_item) {
              let related_item = this.order.items.find(itm => itm.associated_to && itm.associated_to == item.row_id && itm.item_code == modifier.associated_item)
              if (related_item && related_item.notes) modifier.notes = related_item.notes
            }
          }
        }
        return item
      })
    },
    grouped_items() {
      const visible_item_codes = this.visible_items.map(i => i.item_code)
      const get_non_grouped_modifiers = (item) => {
        if (!Array.isArray(item.modifiers)) return item.modifiers
        return item.modifiers.filter(m => !visible_item_codes.includes(m.associated_item))
      }
      const get_sorted_modifiers = (item) => {
        return (item && item.modifiers) ? item.modifiers.toSorted((a, b) => {
          if (a.type === b.type) {
            return a.associated_item.localeCompare(b.associated_item)
          }
          return a.type.localeCompare(b.type)
        }) : [];
      }
      const are_items_eq = (item_a, item_b) => {
        if (item_a.item_code !== item_b.item_code) return false

        if (!Array.isArray(item_a.modifiers) && !Array.isArray(item_b.modifiers)) return true
        if (Array.isArray(item_a.modifiers) !== Array.isArray(item_b.modifiers)) return false

        const modifiers_a = get_sorted_modifiers(item_a)
        const modifiers_b = get_sorted_modifiers(item_b)

        if (modifiers_a.length !== modifiers_b.length) return false

        for (let i = 0; i < modifiers_a.length; i++) {
          if (modifiers_a[i].associated_item !== modifiers_b[i].associated_item || modifiers_a[i].type !== modifiers_b[i].type) return false
        }

        return true
      }
      const items = []
      outer: for (const item of this.visible_items) {
        const item_a = { ...item, modifiers: get_non_grouped_modifiers(item) }
        for (const item_b of items) {
          if (are_items_eq(item_a, item_b)) {
            item_b.qty += item_a.qty
            continue outer
          }
        }
        items.push(item_a)
      }
      const exclude = new Set(Array.isArray(this.settings.excluded_groups) ? this.settings.excluded_groups : [])
      return items
        .toSorted((a, b) => this.item_sorted_order(a) - this.item_sorted_order(b))
        .filter(i => !exclude.has(i.item_group))
    },
    other_items() { return this.visible_items.length != this.order.items.filter(item => !item.associated_to).length },
    ...mapState(['settings', 'orders']),
    status_map() {
      return {
        'Pending': {color: '#3A3B3C', 'next': (this.settings.enable_preparing ? 'In Progress' : 'Ready')},
        'In Progress': {color: '#DC582A', next: 'Ready'},
        'Ready': {color: '#118746', next: 'Pending'}
      }
    },
    time_class() {
      const diff = this.$moment().diff(this.$moment(this.order.posting_date + " " + this.order.posting_time), 'minutes')
      if (diff < 5) return 'time1'
      else if (diff < 10) return 'time2'
      else if (diff < 15) return 'time3'
      else return 'time4'
    },
    is_deleted_order() {
      return this.order.is_deleted && !this.order.docstatus
    },
    is_updated_order() {
      return (this.order.version ?? 0) > 1
    },
    service_icon_map() {
      const saved = this.settings.service_type_mapping
      const has_values = saved && Object.values(saved).some(v => v && v.trim())
      return has_values
        ? saved
        : { 'Dine In': 'F', 'Takeaway': 'T', 'Delivery': 'D' }
    },
    service() {
      const mapping = this.service_icon_map
      return mapping[this.order.food_service] || ''
    },
    service_is_icon() {
      const val = this.service
      return val && val.startsWith('mdi-')
    },
    // --- Feature 1: Secondary Server Indicator ---
    is_secondary_order() {
      return !!this.$store.state.secondary_order_ids[this.order_id]
    },
    // CSS custom properties applied to the root element so they cascade through
    // display:contents wrappers and override !important background rules via the
    // .kds-secondary-order CSS class selector (see global styles below).
    secondary_css_vars() {
      if (!this.is_secondary_order) return {}
      const color = this.settings.secondary_server_card_bg_color || ''
      const image = this.settings.secondary_server_card_bg_image || ''
      if (!color && !image) return {}
      return {
        '--secondary-order-bg-color': color || 'transparent',
        '--secondary-order-bg-image': image ? `url('${image}')` : 'none',
      }
    },
    // --- Feature 2: Dynamic bump-bar index ---
    // Returns a 1-8 relative index when this order is within the current
    // bump-bar page window, or null when it is outside (badge is hidden).
    display_index() {
      const relative = this.index - this.page_offset
      return (relative >= 1 && relative <= 8) ? relative : null
    },
    caption() { return this.order.caption != this.items[0].item_name ? this.order.caption : '' },
  },
  methods: {
    getShorthandTime(time) {
      const diff = this.$moment().diff(this.$moment(time), 'seconds');
      const absDiff = Math.abs(diff);

      if (absDiff < 60) return absDiff + 's';
      if (absDiff < 3600) return Math.floor(absDiff / 60) + 'm';
      if (absDiff < 86400) return Math.floor(absDiff / 3600) + 'h';
      return Math.floor(absDiff / 86400) + 'd';
    },
    async next(item) {
      if (!this.order || !item) return

      const item_idx = item.idx - 1
      const status_curr = item.status
      const status_next = this.status_map[status_curr ?? 'Pending']?.next ?? 'In Progress'
      this.$store.commit('SET_ITEM_STATUS', { order_id: this.order_id, item_idx, status: status_next })
      const auto_completed = this.check_complete()
      if (auto_completed) {
        this.$store.commit('SET_ORDER_STATUS', { order_id: this.order_id, status: true })
        this.syncOrderStatus({ order_id: this.order_id })
      }
      this.save_order({
        order_id: this.order_id,
        on_success: () => {
          this.$root.toast.show({message: 'Success'})
        },
        on_fail: (e, result) => {
          this.$root.toast.show({message: result, type: 'error'})
          this.$store.commit('SET_ITEM_STATUS', { order_id: this.order_id, item_idx, status: status_curr })
        },
      })
    },
    async hide() {
      const status_curr = this.order.hidden
      this.$store.commit('SET_ORDER_STATUS', { order_id: this.order_id, status: !status_curr })
      this.syncOrderStatus({ order_id: this.order_id })
      this.save_order({
        order_id: this.order_id,
        on_success: () => {
          this.$root.toast.show({message: ( this.order.hidden ? 'Order Completed' : 'Order Restored')})
        },
        on_fail: (e, result) => {
          this.$root.toast.show({message: result, type: 'error'})
          this.$store.commit('SET_ORDER_STATUS', { order_id: this.order_id, status: status_curr })
        },
      })
    },
    status_class(item) {
      if (item.is_deleted && !(this.order.is_deleted && !this.order.docstatus)) return 'deleted';
      return (item.status || 'Pending').replace(" ","-").toLowerCase()
    },
    check_complete() {
      return this.order.items.filter(item => !item.associated_to).reduce((acc, itm) => {
        return acc && itm.status == 'Ready'
      }, true)
    },
    item_sorted_order(item) {
      const groups_visible = this.settings.selected_groups
      const order = groups_visible.reduce((acc, cur, idx) => { return { ...acc, [cur]: idx } }, {})
      return Object.hasOwn(order, item.item_group) ? order[item.item_group] : groups_visible.length
    },
    ...mapActions({
      load_orders: 'LOAD_ORDERS',
      save_order: 'SAVE_ORDER',
      syncOrderStatus: 'SYNC_ORDER_STATUS_TO_LOCAL',
    }),
  }
}
</script>

<style scoped lang="scss">
.status-deleted .item-name-text {
  text-decoration: line-through;
  color: #451515; /* Dark Red Text */
}

.deleted {
  background-color: #ef4444; /* Bright Red */
}

.kds-ghost-child {
  width: 300px !important;
  margin-right: 40px !important;
  margin-top: 8px !important;
  display: flex !important;
  position: relative;
}
.kds-ghost-item {
  width: 300px !important;
  margin-right: 40px !important;
  background-color: white !important; /* Keep this white */
  display: flex !important;
  position: relative;
  z-index: 1;
  border-bottom: 1px solid #f1f5f9;
}


.order-counter {
  background-color: #607d8c;
  color: white;
  border-radius: 12px;

  &.counter-deleted { background-color: #dc2626; }
  &.counter-updated { background-color: #e67e00; }
  &.counter-green { background-color: #4CAF50; }

  width: 90px;
  height: 24px;

  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);

  z-index: 10;
  margin: 0;

  text-align: center;
  font-weight: 800;
  font-size: 0.85rem;
  line-height: 22px;
  display: flex;
  justify-content: center;
}

.kds-item-row {
  display: flex;
  align-items: stretch;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.2s;
  width: 100%;

  &:hover { background-color: #f8fafc; }
  &.status-ready {
    background-color: #dcfce7 !important;
    opacity: 1;
    border-bottom-color: #bbf7d0;
  }
}

.kds-item-qty-box {
  flex: 0 0 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: white;
  min-height: 50px;

  .qty-val { font-size: 1.3rem; font-weight: 900; line-height: 1; }
  .uom-val { font-size: 0.65rem; text-transform: uppercase; font-weight: normal; }
}

.kds-item-content {
  flex: 1;
  padding: 8px 12px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .item-name-text { font-weight: bold; color: #475569; font-size: 1.1rem; line-height: 1.2; }
  .item-time-text { font-size: 0.8rem; color: #94a3b8; white-space: nowrap; margin-left: 8px; }
  .item-note-text { color: #ca8a04; font-size: 0.9rem; margin-top: 4px; font-style: italic; }
  .modifier-text { color: #64748b; font-size: 0.9rem; margin-top: 2px; }
}

/* Status colors */
.pending { background: linear-gradient(145deg, #a12f3e, #8a1d2b); }
.in-progress { background-color: #DC582A; }
.ready { background-color: #118746; }

/* Helpers */
.rounded-t { border-radius: 4px 4px 0 0 !important; }
.rounded-b { border-radius: 0 0 4px 4px !important; }
.mb-4 { margin-bottom: 16px !important; }

</style>

<style lang="scss">
  @import "~vuetify/src/components/VTimeline/_variables.scss";
  $timeline-item-padding: 12px;
  $timeline-divider-width: 30px;
  @import "~vuetify/src/components/VTimeline/VTimeline.sass";

  .kds-index-badge {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    text-align: center;
    line-height: 18px;
    font-weight: bold;
    font-size: 12px;
    box-shadow: 1px 1px 3px rgba(0,0,0,0.3);
        flex-shrink: 0;
    display: inline-block;
  }

  .light-badge {
    background-color: #37474F; /* Dark Grey */
    color: white;
    border: 2px solid white;
  }

  .dark-badge {
    background-color: #FFD700; /* Gold */
    color: black;
    border: 2px solid #333;
    display: inline-block;
  }

  /* Title indicator: Updated order (orange) */
  .title-updated {
    background-color: #e67e00 !important;
    color: white !important;
  }

  /* Title indicator: Deleted order (red) */
  .title-deleted {
    background-color: #dc2626 !important;
    color: white !important;
  }

  /* Selection glow - normal card */
  .selected-order-border {
    border: 4px solid #FFD700 !important;
    animation: glow-gold 1.2s ease-in-out infinite alternate;
    transition: all 0.2s ease-in-out;
    transform: scale(1.02);
  }
  @keyframes glow-gold {
    0% { box-shadow: 0 0 8px rgba(255, 215, 0, 0.4), 0 0 16px rgba(255, 215, 0, 0.2) !important; }
    100% { box-shadow: 0 0 16px rgba(255, 215, 0, 0.8), 0 0 32px rgba(255, 215, 0, 0.4) !important; }
  }

  /* Selection glow - dark mode header */
  .selected-order-header {
    border: 2px solid #FFD700 !important;
    box-shadow: 0 0 10px #FFD700;
    position: relative;
    z-index: 10;
  }

  /* Selection left/right borders for ghost mode items */
  .selected-order-side {
    border-left: 3px solid #FFD700 !important;
    border-right: 3px solid #FFD700 !important;
    animation: glow-gold-side 1.2s ease-in-out infinite alternate;
  }
  @keyframes glow-gold-side {
    0% { filter: drop-shadow(0 0 4px rgba(255, 215, 0, 0.3)); }
    100% { filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.7)); }
  }

  /* Left/right border indicator: Updated order (orange) - ghost mode items */
  .indicator-updated-side {
    border-left: 3px solid #e67e00 !important;
    border-right: 3px solid #e67e00 !important;
  }

  /* Left/right border indicator: Deleted order (red) - ghost mode items */
  .indicator-deleted-side {
    border-left: 3px solid #dc2626 !important;
    border-right: 3px solid #dc2626 !important;
  }

  /* --- Feature 1: Secondary Server Order Indicator ---
   * Applied via CSS custom properties set on the root wrapper element.
   * Uses !important to override the kds-ghost-item white background rule. */
  .kds-secondary-order {
    .kds-item-row,
    .kds-ghost-item,
    .kds-item {
      background-color: var(--secondary-order-bg-color, transparent) !important;
      background-image: var(--secondary-order-bg-image, none) !important;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  /* Existing Styles */
  .dark-mode { .title { background-color: rgb(0, 0, 0, 0.5); opacity: 0.8; } }
  .kds-item { width: 300px; margin: 0px 5px; margin-top: 2px !important; flex-wrap: wrap; flex: 0 1 auto !important; }
  .kds-break { width: 300px; height:  10px; margin: 2px 25px; flex: 0 1 auto !important; }
  .time1 { background-color: rgb(125, 132, 147, 1); }
  .time2 { background-color: rgb(182, 184, 74, 1); }
  .time3 { background-color: #edd142; }
  .time4 { background-color: rgb(169, 55, 72, 1); }
  .pending { background: radial-gradient(rgb(192, 118, 129, 1), rgb(167, 54, 67, 1), rgb(161, 47, 62, 1)); }
  .in-progress { background-color: #DC582A; }
  .ready { background-color: rgb(0, 0, 0, 0.4); }
</style>
